import { colors, defaultChartPalette } from '../../utils/palette';
import { AxisDomain, ChartSerie } from './ChartsTypes';

export const getSeries = (
  chartData: {
    __xAxis__: string;
  }[],
  palette?: string[]
) => {
  const keysStackedBarChartData = new Set();
  for (const [, value] of Object.entries(chartData)) {
    Object.keys(value).map((v) => keysStackedBarChartData.add(v));
  }

  const newSeries: ChartSerie<string>[] = [];
  const keysAsArray = Array.from(keysStackedBarChartData).filter((k) => k !== '__xAxis__');
  const palettes = palette || defaultChartPalette;
  for (let i = 0; i < keysAsArray.length; i++) {
    newSeries.push({
      name: keysAsArray[i] as string,
      color: palettes[i] || colors.productsAnalytics.octonary,
      tooltipLabel: keysAsArray[i] as string,
      stackId: 'total',
    });
  }

  return newSeries;
};

export const getTicks = ({ min, max, ticksGap }: AxisDomain): number[] => {
  const ticks: number[] = [];
  for (let tick = min; tick <= max; tick += ticksGap) {
    ticks.push(tick);
  }
  if (ticks[ticks.length - 1] !== max) {
    ticks.push(max);
  }
  return ticks;
};
